import { useEffect } from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";
import { useFormDefaultValuesFromQuery } from "./useFormDefaultValuesFromQuery";

export const useSyncFormWithQueryData = <
  T extends { id: string },
  F extends FieldValues,
  K extends string = "entries",
>(
  data: T[] | undefined,
  form: UseFormReturn<F>,
  recordKey?: K,
) => {
  const formData = useFormDefaultValuesFromQuery<T, K>(data, recordKey);

  useEffect(() => {
    if (data === undefined) {
      return;
    }
    /**
     * Resets the form with the new data, keeping the dirty values if the form is dirty.
     * This is used to sync the form with the query data when the query data changes.
     */
    form.reset(formData as unknown as F, {
      keepDirtyValues: form.formState.isDirty,
    });
  }, [data, form, formData]);
};
